<template>
	<div>

		<div class="col-md-2" ref="ul">
			<div class="tab_holderrs">
				<div v-show="tab.isShown" v-for="(tab, index) in tabs" class="inv_tab" :class="{ 'active': tab.isActive }">
					<a href="#" v-html="tab.name" @click.prevent="selectTab(tab)"></a>
				</div>
			</div>
		</div>

		<div class="col-md-10">
			<slot></slot>
		</div>

	</div>
</template>

<script>
	export default {
		props: {},
		created() {
			this.tabs = this.$children;
		},
		mounted() {},
		data() {
			return {
				tabs: [],
			};
		},
		computed: {},
		methods: {
			/**
			 * Set active tab.
			 *
			 * @param selectedTab
			 */
			selectTab(selectedTab) {
				this.$emit('tabSelected', selectedTab);

				this.tabs.forEach(tab => {
					tab.isActive = (tab === selectedTab);
				});
			},
		}
	}
</script>